var throttle = require('lodash.throttle');

/*
 * All sections level 1-3 should be loaded by default when scrolling
 * Sections level 4+ should only be loaded when clicking read more button of level 3 parent section
 */

(function ($) {
	if ($('.js-report-section').length < 1) {
		return;
	}

	$(document).on('click', '.js-disable-report-loading', function () {
		console.log('click disable report loading');
		if (window.cookieHandler.getCookie('DisableReportLoading') === 'true') {
			window.cookieHandler.deleteCookie('DisableReportLoading');
		} else {
			window.cookieHandler.setCookie('DisableReportLoading', 'true', 365);
		}
		location.reload();
	});

	if (window.cookieHandler.getCookie('DisableReportLoading') === 'true') {
		$('.js-disable-report-loading').addClass('is-disabled');
		return;
	}

	// Links in menu is used as master for controlling content loading order
	var allLinks = $('.sidebar-menu .navigation-items a').map(function () {
		return { 'url': $(this).attr('href'), 'level': $(this).data('level')};
	}).get();
	allLinks.shift(); // Remove duplicated startpage link form allLinks list
	var scrollThreshold = $(window).height() * 2;
	var $mainContent = $('#main-content');
	var mainContentOffset = $mainContent.offset().top; //Behövs denna?
	var lastLoadedUrl = window.location.pathname.replace(/\/?$/, '/'); //Add trailing "/" if missing from url
	var pendingContent = [];

	// Called from loadContentOnScroll() to load level4+ sections
	function loadSection($section) {

		$.ajax({
			url: $section.data('id') + 'LoadPartial',
			type: 'GET',
			dataType: 'json',
			success: function (data) {
				$section.replaceWith(data.InnerHtml);
				updateContent();
			},
			error: function (error) {
				console.log('error: ', error);
			}
		});
	}

	// Called from loadContentOnScroll() to load last/next section at bottom
	function loadContent() {
		var linkIndex = allLinks.findIndex(function (link) { return link.url === lastLoadedUrl; });
		var newLinkIndex = linkIndex + 1;
		var expandAllChapters= $('.report-page--expanded').length;

		if (linkIndex < 0 || newLinkIndex >= allLinks.length) {
			return;
		}

		lastLoadedUrl = allLinks[newLinkIndex].url;

		var nextLinkObj = allLinks[newLinkIndex];

		//If level is larger than 3 and "expand-checkbox" == false, then append placeholder section
		if (nextLinkObj.level > 3 && !expandAllChapters) {
			var content = {
				'InnerHtml': '<section class="js-report-section js-report-unloaded-section" data-id="' +
				nextLinkObj.url + '"></section>'
			};

			verifyPosition(newLinkIndex, content);

			//Recursive call to load all level 4+ section placeholders
			loadContent();
			return;
		}

		if (linkIndex >= 0 && linkIndex < allLinks.length - 1) {
			$.ajax({
				url: allLinks[newLinkIndex].url + 'LoadPartial',
				type: 'GET',
				dataType: 'json',
				success: function (data) {
					verifyPosition(newLinkIndex, data);
				},
				error: function (error) {
					console.log('error: ', error);
				}
			});
		}
	}

	// Verify item can be placed as last section
	function verifyPosition(linkIndex, content) {
		var lastAppendedContentUrl = $('.js-report-section').last().data('id');
		//Check if current content should be appended next
		if (lastAppendedContentUrl === allLinks[linkIndex - 1].url) {
			appendContent(content);

			//Check if current content exists in pending content and remove
			if (pendingContent.findIndex(function(item) { return item.linkIndex === linkIndex; }) !== -1) {
				pendingContent.splice(pendingContent.findIndex(function (item) {
					return item.linkIndex === linkIndex;
				}), 1);
			}

			if (pendingContent.length > 0) {
				checkPendingContent();
			}
		}
		//Save content to pending list
		else if (pendingContent.findIndex(function (item) { return item.linkIndex === linkIndex; }) === -1) {
			var newContent = { 'content': content, 'linkIndex': linkIndex };
			pendingContent.push(newContent);
		}
	}

	//Verify position on all pending items
	function checkPendingContent() {
		for (var i = 0; i < pendingContent.length; i++) {
			verifyPosition(pendingContent[i].linkIndex, pendingContent[i].content);
		}
	}

	function updateContent() {
		window.scrollspy.updateSections();
		window.responsiveTables.updateTables();
		window.graphblock.updateGraphblocks();
		window.footnotes.updateFootnotes();
		window.tooltip.updateTooltipDict();
		window.checkLongTitles();
		if (typeof window.MathJax !== 'undefined') {
			window.MathJax.typeset();
		}
	}

	// appending to bottom
	function appendContent(data) {
		$('.js-load-more-content').before(data.InnerHtml);
		updateContent();
	}

	//Load level 4 sections
	function loadLevel4Sections($currentSection) {
		var nextLevel3Section = '.js-report-section:not(.js-report-unloaded-section)';
		var $unloadedSections = $currentSection.nextUntil(nextLevel3Section, '.js-report-unloaded-section');

		$unloadedSections.each(function () {
			loadSection($(this));
		});

		window.scrollspy.updateSections();
	}

	// scroll event actions
	function loadContentOnScroll() {
		var scrollPosition = $(window).scrollTop() - mainContentOffset;
		var contentHeight = $mainContent.height();

		if (contentHeight - scrollPosition < scrollThreshold) {
			loadContent();
		}

		var sectionsToBeLoaded = $('.js-report-section-load');

		// Check each unloaded section and load if user scroll position is within threshold
		sectionsToBeLoaded.each(function() {
			var sectionDistanceFromTop = $(this).offset().top - mainContentOffset;
			if (sectionDistanceFromTop - scrollPosition < scrollThreshold) {
				loadSection($(this));
			}
		});

		//If landing on level 4 sections, load all siblings
		var $firstSection = $('.js-report-section').first();
		if ($firstSection.hasClass('report-level-4')) {
			loadLevel4Sections($firstSection);
		}
	}

	// Load first section from start if visiting new report
	if ($('.report-theme-3')) {
		loadContent();
	}

	$(window).on('scroll', throttle(loadContentOnScroll, 250, { trailing: true, leading: true }));

	// Enable loading of children when clicking on read more button
	$(document).on('click', '.js-read-more-button', function () {
		var $currentSection = $(this).closest('.js-report-section');
		$currentSection.addClass('expanded');
		$(this).hide();
		loadLevel4Sections($currentSection);
		var $submenu = $('#sub-menu');
		var $menuLink = $($submenu.find('[data-id="' + $currentSection.data('id') + '"]')[0]);
		var menuExpandButton = $menuLink.parent().find('.js-open-sub-menuitems');
		menuExpandButton.click();

		updateContent();
	});
})(jQuery);
